// extracted by mini-css-extract-plugin
module.exports = {"container":"Time_container__3u5ui","iconState":"Time_iconState__3kYlH","label":"Time_label__3lh1D"};